var _path;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgFinances(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "96px",
    height: "96px",
    viewBox: "0 0 96 96",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    id: "Icons_PiggyBank",
    overflow: "hidden",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M83 49C82.5 49 82.1 48.7 81.8 48.4 81.3 47.9 81 47 81 46.1 81 44.8 81.9 43.8 82.7 43.2L82.8 43.1C84.7 44.1 85 45.1 85 46 85 47.6 84.1 49 83 49ZM55.8 29.3C55.5 30 54.7 30.5 54 30.5 53.7 30.5 53.4 30.4 53.2 30.3 50 28.8 46.5 28 43.2 28 41.3 28 39.4 28.3 37.5 28.8 36.4 29.1 35.3 28.5 35 27.4 34.7 26.3 35.3 25.2 36.4 24.9 38.6 24.3 40.9 24 43.1 24 46.9 24 51 24.9 54.7 26.6 55.8 27.1 56.3 28.3 55.8 29.3ZM90.3 37C87.8 36.6 84.7 37.3 82.2 38.7 79.9 38.2 76.4 38.2 73.2 39.3 68.5 28.1 55.4 20 43 20 38.7 20 34.4 21 30.5 22.8L18.2 17C17.4 16.6 16.5 17.4 16.8 18.2L20.8 29.5C18.4 32 16.4 34.9 15 38.1 14.8 38.7 14.3 39.1 13.6 39.3L10 40.2C8.2 40.6 7 42.2 7 44.1L7 51.9C7 53.7 8.2 55.3 10 55.8L13.7 56.7C14.3 56.9 14.8 57.3 15.1 57.9 16.8 61.8 19.4 65.3 22.6 68.2 22.9 68.5 23.2 68.9 23.3 69.4L24.8 78.5C25 79.5 25.8 80.2 26.8 80.2L33.4 80.2C34.4 80.2 35.2 79.5 35.4 78.5L35.9 75.3C38.2 75.9 40.6 76.2 43.1 76.2 45.8 76.2 48.6 75.8 51.2 75.1L51.8 78.5C52 79.5 52.8 80.2 53.8 80.2L60.4 80.2C61.4 80.2 62.2 79.5 62.4 78.5L63.9 69.4C64 68.9 64.2 68.5 64.6 68.2 70.7 62.9 75 55.9 75 48 75 46.3 74.8 44.7 74.4 43.1 75.6 42.7 76.9 42.4 78.1 42.4 77.4 43.5 77 44.7 77 46 76.9 48 77.7 49.9 79 51.3 80.1 52.4 81.5 53.1 83 53.1 86.3 53.1 89 50 89 46.1 89 44.2 88.3 42.5 86.9 41.2 87.9 41 88.8 40.9 89.7 41 90.8 41.2 91.8 40.4 92 39.3 92.1 38.2 91.4 37.2 90.3 37Z",
    fill: "#FFFFFF"
  })));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFinances);
export default __webpack_public_path__ + "static/media/finances.2fc3336c2af06dfb6d8c2966fc1bec37.svg";
export { ForwardRef as ReactComponent };